import React from 'react';
import classNames from 'classnames';
import { HyperdbListing } from '../../../../hyperdb';

export default HyperdbListing({
  collectionName: 'listing_contents',
  namespace: 'listingContent',
  mountedUrl: '/content/listings',
  title: 'Contents for listings',
  columns: [
    { attribute: 'name' },
    { attribute: 'node_uid', sortable: false },
  ],
});



// WEBPACK FOOTER //
// ./src/frontend/modules/content/listing-content/containers/Listing.jsx